import { Exclude, Type } from 'class-transformer'

export class SpecializzazioneAttivita {
  id!: number;
  idSpecializzazioneII!: number;
  nome!: string;
}

export class SpecializzazioneVoce {
  id!: number;
  idSpecializzazione!: number;
  nome!: string;
  @Type(() => SpecializzazioneAttivita)
  specIII!: SpecializzazioneAttivita[];
}

export class Specializzazione {
  deleted!: boolean;
  id!: number;
  nomeSpecializzazione?: string;
  nomespecializzazione?: string;
  @Type(() => SpecializzazioneVoce)
  specII!: SpecializzazioneVoce[];
  @Type(() => SpecializzazioneVoce)
  specIII!: SpecializzazioneVoce[];

  @Exclude()
  get nome(): string | undefined {
    return this.nomeSpecializzazione || this.nomespecializzazione;
  }
}
